import './checkout_vouchers';
import './checkout_loyalty';

loadjs.ready(['jquery', 'core'], function() {
    var $errors;
    var $cartItemModal = $('#cart-item-modal');
    var $cartItemQuantityModal = $('#cart-item-quantity-modal');
    var $cartItemRemoveModal = $('#cart-item-remove-modal');
    var updateApp = function(metadata) {
        if (window.inApp && metadata) {
            window.ReactNativeWebView.postMessage(JSON.stringify({action: 'update', type: 'cart', value: metadata.items_count_quantity}));
        }
    }
    var getGiftWrappingModal = function(url, cb) {
        preloader(1);
        $.get(url, function (response) {
            var $modal;
            if (!response) {
                preloader(0);
                return;
            }
            $modal = $(response);
            $modal.find('.icon').icon();
            $modal.find('form.needs-validation').formValidate();
            $modal.appendTo('body');

            setTimeout(function () {
                preloader(0);
                $modal.one('modal:shown', function() {
                    $modal.find('.slider').slider();
                })
                if (cb) {
                    cb($modal);
                }
            }, 200);
        });
    }
    var setShippingEstimation = function() {
        var $estimation = $('#shipping-cost-estimation');
        window.setLocationCookie.then(function() {
            $.getJSON(routes.checkout.shippingEstimation.replace('_token_', token), function (response) {
                $estimation.html(response.cost ? response.cost : 'de la 0 LEI');
            });
        });
    }
    $('#checkout-vouchers-modal').on('voucher:added voucher:removed', function (e) {
        var $el = $(this);
        updateFragment('vouchers', function() {
            $el.modal('hide');
        })
        updateFragment('summary', setShippingEstimation)
    })
    $body.on('loyalty:added loyalty:removed', function() {
        updateFragment('loyalty')
        updateFragment('summary', setShippingEstimation)
    })

    $('.cart-items')
        .on('click', '.cart-item', function(e) {
            var $el = $(this);
            var data = $el.data();
            var q = data.maxquantity < data.quantity ? data.maxquantity : data.quantity;

            e.preventDefault();
            e.stopImmediatePropagation();

            $cartItemModal
                .data('item', $el)
                .find('.item-link').attr('href', data.url).attr('data-product', data.productHash).end()
                .find('.item-quantity').html(data.quantity);
            $cartItemQuantityModal
                .find('form')[0].validator.reset();
            $cartItemQuantityModal
                .find('input[name="id"]').val(data.ci).end()
                .find('input[name="quantity"]').val(q).attr('max', data.maxquantity)

            $cartItemModal.modal('show');
        })
        .on('click', '.item-change', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();

            preloader(1);
            location.href = $(this).data('href');
        });
    $cartItemQuantityModal
        .on('modal:shown', function() {
            $cartItemQuantityModal.find('input[name="quantity"]').focus().data('fakeFocus').remove();
        })
        .on('success', function (e, r) {
            var $item = $cartItemModal.data('item');
            var q = parseInt($cartItemQuantityModal.find('input[name="quantity"]').val());
            preloader(1);
            $item.find('.quantity').html(q);
            $item.data('quantity', q);
            $item.find('.item-error').remove();
            updateApp(r.metadata);
            if (r.should_refresh) {
                location.reload();
            } else {
                updateFragment('summary', function () {
                    setShippingEstimation();
                    $cartItemQuantityModal.modal('hide');
                    $cartItemModal.modal('hide');
                });
            }
        })

    $cartItemModal
        .on('click', '.item-link', function () {
            let $el = $(this);
            if ($cartItemModal.data('item').data('type') !== 'gift_wrap') {
                $cartItemModal.modal('hide')
                return true;
            }

            let id = 'gift-wrapping-modal-' + $cartItemModal.data('item').data('ci');
            let $m = $('#' + id);

            $cartItemModal.one('modal:hidden', function() {
                $m.modal('show');
            })

            if (!$m.length) {
                getGiftWrappingModal($el.attr('href'), function($modal) {
                    $modal.attr('id', id);
                    $m = $modal;
                    $cartItemModal.modal('hide');
                })
            } else {
                $cartItemModal.modal('hide');
            }

            return false;
        })
        .on('click', '.item-remove', function() {
            $cartItemRemoveModal.find('input[name="id"]').val($cartItemModal.data('item').data('ci'));
            if ($(this).data('extra') === 'favorite') {
                $cartItemRemoveModal.find('input[name="favorite"]').val(1);
                $cartItemRemoveModal.find('form').submit();
            } else {
                $cartItemRemoveModal.find('input[name="favorite"]').val(0);
                $cartItemRemoveModal.modal('show');
            }
            return false;
        })
        .on('click', '.change-quantity', function(e) {
            var $quantityInput = $cartItemQuantityModal.find('input[name="quantity"]');
            $quantityInput.prop('readonly', false);
            $quantityInput.data('fakeFocus', $quantityInput.fakeFocus());
            return true;
        });

    $cartItemRemoveModal
        .on('success', function(e, r) {
            var $item = $cartItemModal.data('item');
            updateApp(r.metadata);
            dilytics('product', 'removeFromCart', [$item.data('product')])
            gtag('event', 'remove_from_cart', {
                "items": [
                    {
                        "id": $item.data('sku'),
                        "name": $item.data('title'),
                        "list_name": "Cart",
                        "brand": $item.data('brand'),
                        "category": "",
                        "variant": $item.data('variant'),
                        "quantity": $item.data('quantity'),
                        "price": $item.data('price')
                    }
                ]
            });

            if ($item.siblings().length === 0) {
                location.reload();
            } else {
                $item.remove();
                updateFragment('summary', function () {
                    setShippingEstimation();
                    $cartItemRemoveModal.modal('hide');
                    $cartItemModal.modal('hide');
                });
            }
        })

    $('#cart-summary-fragment')
        .on('click', '.modal-toggle', function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            $($(this).attr('href')).modal('show');
        })
        .on('click', '.continue', function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            preloader(1);
            location.href = $(this).attr('href');
        })

    $('.is-gift-wrapping').click(function(e) {
        var $el = $(this);
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if ($el.data('modal')) {
            $el.data('modal').modal('show');
            return false;
        }

        getGiftWrappingModal($el.data('xhr'), function($modal) {
            $modal.removeAttr('id');
            $modal.find('form').on('success', function(e, r) {
                updateApp(r.metadata);
                preloader(1);
                location.reload();
            });
            $el.data('modal', $modal);
            $modal.modal('show');
        })
        return false;
    });

    setShippingEstimation();

    if (hasErrors) {
        $errors = $('.item-error');
        if ($errors.length) {
            $('html,body').animate({
                scrollTop: $errors.first().offset().top - 100
            }, {
                duration: 400,
                queue: false
            })
        }
    }
});